import { makeVar } from "@/hooks/useVar.tsx";

export const practiceVar = makeVar<boolean>(false);
